import { MoreOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu } from 'antd'

import { sortNumericColumn, sortStringColumn } from '../../../../components/tables/utils'
import { MaturityComplianceRule } from './models'

const renderActionsMenu =
  ({
    onDelete,
    onUpdate,
  }: {
    onDelete: (rule: MaturityComplianceRule) => void
    onUpdate: (rule: MaturityComplianceRule) => void
  }) =>
  (_: any, rule: MaturityComplianceRule) => {
    const menu = (
      <Menu>
        <Menu.Item key="updateRule" onClick={() => onUpdate(rule)}>
          Update Compliance Rule
        </Menu.Item>
        <Menu.Item key="deleteRule" onClick={() => onDelete(rule)}>
          Delete Compliance Rule
        </Menu.Item>
      </Menu>
    )

    return (
      <Dropdown placement="bottomRight" overlay={menu}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    )
  }

export const buildMaturityComplianceRulesTableColumns = ({
  onDelete,
  onUpdate,
}: {
  onDelete: (rule: MaturityComplianceRule) => void
  onUpdate: (rule: MaturityComplianceRule) => void
}) => [
  {
    title: 'Label',
    dataIndex: 'displayTextKey',
    sorter: sortStringColumn({ dataIndex: 'displayTextKey' }),
  },
  {
    title: 'Maturity Days From',
    dataIndex: 'maturityDaysFrom',
    sorter: sortNumericColumn({ dataIndex: 'maturityDaysFrom' }),
  },
  {
    title: 'Maturity Days To',
    dataIndex: 'maturityDaysTo',
    sorter: sortNumericColumn({ dataIndex: 'maturityDaysTo' }),
  },
  {
    title: 'Min Limit',
    dataIndex: 'minLimit',
    sorter: sortNumericColumn({ dataIndex: 'minLimit' }),
  },
  {
    title: 'Max Limit',
    dataIndex: 'maxLimit',
    sorter: sortNumericColumn({ dataIndex: 'maxLimit' }),
  },
  { title: '', render: renderActionsMenu({ onDelete, onUpdate }) },
]
